"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("./Api"));
class default_1 extends Api_1.default {
    constructor(props) {
        super(props);
    }
    /**
     * Podio get requests
     * @param url
     * @param data
     * @returns
     */
    get(url, data = {}) {
        const requestObj = {
            method: 'get',
            url,
            data,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Podio post requests
     * @param url
     * @param data
     * @returns
     */
    post(url, data = {}) {
        const requestObj = {
            method: 'post',
            url,
            data,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Podio put requests
     * @param url
     * @param data
     * @returns
     */
    put(url, data = {}) {
        const requestObj = {
            method: 'put',
            url,
            data,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Podio patch requests
     * @param url
     * @param data
     * @returns
     */
    patch(url, data = {}) {
        const requestObj = {
            method: 'patch',
            url,
            data,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Podio delete requests
     * @param url
     * @param data
     * @returns
     */
    delete(url, data = {}) {
        const requestObj = {
            method: 'delete',
            url,
            data,
        };
        return this._httpRequest(requestObj);
    }
}
exports.default = default_1;
